import script from "./ModalCreateVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCreateVideo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCreateVideo.vue?vue&type=style&index=0&id=7a64c97c&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a64c97c"]])

export default __exports__